export default __webpack_public_path__ + "static/media/myLogo.4c9bf449.png";